import * as React from 'react';

import createStatsigUser from '../utils/createStatsigUser';
import getClientKey from '../utils/getClientKey';
import getClientOptions from '../utils/getClientOptions';
import getInitialValues from '../utils/getInitialValues';
import BootstrapClientSubProvider from './BootstrapClientSubProvider';

const StatsigBootstrapProvider = ({ children }: React.PropsWithChildren<{}>) => {
  const values = getInitialValues();
  const statsigUser = createStatsigUser();
  const clientKey = getClientKey();
  const clientOptions = getClientOptions();

  return (
    <BootstrapClientSubProvider user={statsigUser} values={values} clientKey={clientKey} clientOptions={clientOptions}>
      {children}
    </BootstrapClientSubProvider>
  );
};

export default StatsigBootstrapProvider;
